import { render, staticRenderFns } from "./GeneralDialog.vue?vue&type=template&id=36d80525&scoped=true"
import script from "./GeneralDialog.vue?vue&type=script&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&lang=js"
import style0 from "./GeneralDialog.vue?vue&type=style&index=0&id=36d80525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d80525",
  null
  
)

export default component.exports